export class QuoteGroup {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.dealerContactId = item.dealerContactId;
      this.dealerGroupId = item.dealerGroupId;
      this.dealerGroupName = item.dealerGroupName;
      return;
    }
    this.id = null;
    this.name = '';
    this.dealerContactId = null;
    this.dealerGroupId = null;
    this.dealerGroupName = '';
  }
}
